import IHistoryRequestDTO from "../../../shared/oversight-core/dtos/request-dtos/history-request-dto";
import IDeviceResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/device-response-dto";
import IHistoryResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/history-response-dto";
import IImportExportResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/import-export-response-dto";
import ILatestSnapshotResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/latest-snapshot-response-dto";
import ITimeOfUseResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/time-of-use-response-dto";
import { transformErrorResponse } from "../../../shared/oversight-core/utils/transformErrorResponse";
import { rootApi } from "../apiManager";

export const meterAPI = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    viewAllMeterDevices: builder.query<IDeviceResponseDTO[], void>({
      transformErrorResponse,
      query() {
        return {
          url: `meter/devices`,
          method: "GET",
        };
      },
    }),
    viewMeterTimeOffUse: builder.query<
      ITimeOfUseResponseDTO,
      { deviceId: string }
    >({
      transformErrorResponse,
      query({ deviceId }) {
        return {
          url: `meter/${deviceId}/time-of-use`,
          method: "GET",
        };
      },
    }),
    viewLatestMeterSnapshot: builder.query<
      ILatestSnapshotResponseDTO,
      { deviceId: string }
    >({
      transformErrorResponse,
      query({ deviceId }) {
        return {
          url: `meter/${deviceId}/latest`,
          method: "GET",
        };
      },
    }),
    viewMeterImportExport: builder.query<
      IImportExportResponseDTO,
      { deviceId: string }
    >({
      transformErrorResponse,
      query({ deviceId }) {
        return {
          url: `meter/${deviceId}/import-export`,
          method: "GET",
        };
      },
    }),
    viewMeterHistory: builder.query<IHistoryResponseDTO, IHistoryRequestDTO>({
      transformErrorResponse,
      query(data) {
        const { deviceId, from, to, limit } = data;
        return {
          url: `meter/${deviceId}/history`,
          method: "GET",
          params: { from, to, limit },
        };
      },
    }),
  }),
});

export const {
  useLazyViewAllMeterDevicesQuery,
  useLazyViewMeterTimeOffUseQuery,
  useLazyViewLatestMeterSnapshotQuery,
  useLazyViewMeterImportExportQuery,
  useLazyViewMeterHistoryQuery,
} = meterAPI;
